export enum ImmersionSortBy {
  RECENT = 'RECENT',
  SEQUENCE = 'SEQUENCE'
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/immersion-sort-by.ts